import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n";

const SECTIONS = [
  {
    hi: { h: "वेबसाइट का उपयोग", p: "यह वेबसाइट अंशा वेलफेयर सोसाइटी (पंजीकरण संख्या: VAR/07434/2024-2025) की आधिकारिक जानकारी, गतिविधियों और दान विवरण साझा करने के लिए बनाई गई है।" },
    en: { h: "Use of Website", p: "This website is created to share official information, activities and donation details of Anansha Welfare Society (Registration No: VAR/07434/2024-2025)." },
  },
  {
    hi: { h: "दान संबंधी शर्तें", p: "दान पूर्णतः स्वैच्छिक है। दान केवल वेबसाइट पर प्रदर्शित आधिकारिक भुगतान विवरण के माध्यम से करें। रसीद के लिए दान के बाद संस्था से संपर्क करना आवश्यक है।" },
    en: { h: "Donation Terms", p: "Donations are completely voluntary. Please donate only through the official payment details displayed on this website. Contact the organization after donating to receive a receipt." },
  },
  {
    hi: { h: "सामग्री", p: "वेबसाइट पर उपलब्ध तस्वीरें और सामग्री संस्था की संपत्ति है। बिना अनुमति इसका व्यावसायिक उपयोग न करें।" },
    en: { h: "Content", p: "Photos and content available on this website are the property of the organization. Do not use them commercially without permission." },
  },
  {
    hi: { h: "संपर्क", p: "नियम एवं शर्तों संबंधी किसी भी प्रश्न के लिए हमसे ananshawelfaresociety@gmail.com या +91 9452529739 पर संपर्क करें।" },
    en: { h: "Contact", p: "For any questions about these terms, contact us at ananshawelfaresociety@gmail.com or +91 9452529739." },
  },
];

export default function Terms() {
  const { lang } = useLang();
  return (
    <main>
      <Seo
        title="नियम एवं शर्तें"
        description="Anansha Welfare Society वेबसाइट के उपयोग और दान संबंधी नियम एवं शर्तें।"
        path="/terms"
        breadcrumb={["नियम एवं शर्तें"]}
      />
      <PageHero
        overline={{ hi: "शर्तें", en: "Terms" }}
        title={{ hi: "नियम एवं शर्तें", en: "Terms & Conditions" }}
        testid="terms-page-heading"
      />
      <section className="py-20 bg-ngo-cream">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-8">
          {SECTIONS.map((s, i) => (
            <Reveal key={i} i={i}>
              <div data-testid={`terms-section-${i}`}>
                <h2 className="font-heading font-bold text-2xl text-ngo-ink">{lang === "hi" ? s.hi.h : s.en.h}</h2>
                <p className="mt-3 text-base leading-relaxed text-ngo-ink/70">{lang === "hi" ? s.hi.p : s.en.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
